import { render, staticRenderFns } from "./LevyCalculationPanelLevyCap.vue?vue&type=template&id=508194c9&"
import script from "./LevyCalculationPanelLevyCap.vue?vue&type=script&lang=js&"
export * from "./LevyCalculationPanelLevyCap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports